var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPublishedPrivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visibility_off_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/visibility_off_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67499 3.20433L3.90833 5.43766C2.54999 6.50433 1.47499 7.921 0.833328 9.56266C2.27499 13.221 5.83333 15.8127 9.99999 15.8127C11.2667 15.8127 12.4833 15.571 13.6 15.1293L16.45 17.9793L17.625 16.8043L2.84999 2.021L1.67499 3.20433ZM17.35 9.5627C15.975 6.75436 13.1584 4.97936 10 4.97936C9.43335 4.97936 8.88335 5.05436 8.34168 5.16269L6.96668 3.7877C7.92502 3.47936 8.94168 3.3127 10 3.3127C14.1667 3.3127 17.725 5.90436 19.1667 9.5627C18.5917 11.0294 17.675 12.3127 16.5167 13.3377L15.3417 12.1627C16.1667 11.4544 16.8584 10.5794 17.35 9.5627ZM10.8333 7.65436L9.1083 5.92936C9.39997 5.85436 9.69163 5.8127 9.99997 5.8127C12.0666 5.8127 13.75 7.4877 13.7416 9.55436C13.7416 9.8627 13.6916 10.1627 13.625 10.446L11.9 8.72103C11.6916 8.24603 11.3083 7.8627 10.8333 7.65436ZM6.54997 8.07933L5.09163 6.62099C4.0833 7.38766 3.2333 8.37099 2.64997 9.56266C4.02497 12.371 6.84163 14.146 9.99997 14.146C10.7916 14.146 11.5583 14.0293 12.2916 13.8293L11.475 13.0127C11.025 13.2043 10.525 13.3127 9.99997 13.3127C7.9333 13.3127 6.24997 11.6293 6.24997 9.56266C6.24997 9.03766 6.3583 8.53766 6.54997 8.07933Z",
    fill: "#334D6E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublishedPrivate);
export default __webpack_public_path__ + "static/media/icon-published-private.6093f1f039a80632d0383e8038f25fe5.svg";
export { ForwardRef as ReactComponent };